import localforage from 'localforage';
import memoize from 'lodash-es/memoize';
import { WorkboxPlugin } from 'workbox-core/types.js';

// 改了这个文件记得重新 yarn dev

/**
 * 设置缓存标识，页面上报 pv 时读取这个值判断页面是否来自 service worker 缓存
 * 仅应该在页面缓存策略中使用这个插件
 * 如果也使用了过期插件，应该把过期插件放在插件列表的开头
 */
export const setCacheFlag: WorkboxPlugin = {
  cachedResponseWillBeUsed: async ({ cachedResponse, request }) => {
    console.log('setCacheFlag', 'cachedResponseWillBeUsed');

    if (cachedResponse) {
      setPageCacheTime(request.url, cachedResponse);
    }
    return cachedResponse;
  },
};

async function setPageCacheTime(url: string, cachedResponse: Response) {
  try {
    const cacheTime = getDateHeaderTimestamp(cachedResponse);
    console.log('setPageCacheTime start', url, cacheTime);
    await localforage.setItem(`page_cache_time_${url}`, cacheTime || Date.now());
    console.log('setPageCacheTime success', url);
  } catch (err) {
    console.error('setPageCacheTime error', err);
  }
}

// 为了避免重复计算，使用 memoize 来缓存，这样只会在第一次调用时计算一次，可以删除缓存的值
export const getPageCacheTime = memoize(async (url: string) => {
  const cacheKey = `page_cache_time_${url}`;
  const cacheTime = await localforage.getItem(cacheKey);
  if (cacheTime) {
    localforage.removeItem(cacheKey);
    return Date.now() - Number(cacheTime);
  }
  return 0;
});

// 获取页面的生成时间
function getDateHeaderTimestamp(cachedResponse: Response): number | null {
  if (!cachedResponse.headers.has('date')) {
    return null;
  }

  const dateHeader = cachedResponse.headers.get('date');
  const parsedDate = new Date(dateHeader!);
  const headerTime = parsedDate.getTime();

  // If the Date header was invalid for some reason, parsedDate.getTime()
  // will return NaN.
  if (isNaN(headerTime)) {
    return null;
  }

  return headerTime;
}
